// src/axiosInstance.js

import axios from 'axios';
import { store } from './store'; // Import your Redux store
import { logout } from './features/authSlice'; // Import the logout action

const BASE_URL = process.env.REACT_APP_BACKEND_URL || '/api';

const axiosInstance = axios.create({
    // Prefer env override; default to same-origin. See interceptor below for de-duping '/api'.
    baseURL: BASE_URL,
});

// Request interceptor to add the token to headers
axiosInstance.interceptors.request.use(
    (config) => {
        const token = store.getState().auth.token; // Get token from Redux state
        if (token) {
            config.headers['Authorization'] = `Token ${token}`;
        }

        // Normalize URL to avoid '/api/api/...':
        // If baseURL ends with '/api' and request path starts with '/api/', strip the duplicate prefix.
        // This lets code call '/api/...' while BASE_URL is '/api' or a full '.../api'.
        if (typeof config.url === 'string') {
            const endsWithApi = BASE_URL.endsWith('/api');
            const startsWithApi = config.url.startsWith('/api/');
            if (endsWithApi && startsWithApi) {
                config.url = config.url.replace(/^\/api\//, '/'); // '/api/login/' -> '/login/'
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Token is invalid or expired
            store.dispatch(logout()); // Dispatch the logout action
            window.location.href = '/login'; // Redirect to login
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;